var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"makeorder-page-table-stock-width"},[_c('div',{staticClass:"makeorder-page-table-mobile-header"},[_vm._v("Estoque")]),_vm._v(" "+_vm._s(_vm.product.estoque ? _vm.product.estoque : '-')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }